<template>
  <a
    v-bind="props.action"
    href="#"
    class="relative flex justify-between items-center gap-2"
    @click.prevent="handleNotificationClick(item)"
  >
    <div class="flex flex-col justify-center gap-0.5">
      <div class="flex items-center gap-1.5">
        <i class="pi pi-desktop"></i>
        <span class="text-sm font-semibold text-gray-800 dark:text-gray-200">Device Login Requested</span>
      </div>
      <span class="text-xs text-gray-500">
        <span class="font-medium text-gray-900 dark:text-white">{{ item.device?.userName ?? 'A user' }}</span>
        is trying to log in from a new device
        <span v-if="item.device?.label" class="text-gray-900 dark:text-gray-300">({{ item.device.label }})</span>
      </span>
    </div>
    <span class="text-xs text-gray-500">{{ formatNotificationDate(item.createdAt) }}</span>
    <Badge v-if="!item.readAt" severity="warn" class="absolute top-1.5 right-2" />
  </a>
</template>

<script setup>
/* global defineProps */
import { Badge } from 'primevue'
import { formatNotificationDate } from '@/utils/helpers'

defineProps(['item', 'props', 'handleNotificationClick'])
</script>
